import Vue from 'vue';
import App from './App.vue';
import './plugins/element.js';
import router from './router'; 
import './assets/css/theme/index.scss'; // 引入自定义主题
import ElementUI from 'element-ui';

window.config = {
  //apiUrl: 'http://192.168.1.167/',
  //apiUrl: '/',
  apiUrl: 'http://admin.feitem.com/',
  baiduMapAK:'OjgNzkWfUxo1giUrXbY2Gq39bXB3Plu4',
  mapLng: 114.311643,
  mapLat: 34.824894,
  vrdjUrl:"http://ai.feitem.com/",
};
Vue.config.productionTip = false;

new Vue({
  router, // 在这里注册 router
  render: h => h(App),
  ElementUI
}).$mount('#app');
